import React from "react";
import { DeviceEmergencyCodeEnum } from "lib/enums";
import { someIncludes } from "lib/helpers";
import { GreenPointIcon, ErrorIcon, RepairIcon } from "components/ui";

type Props = {
  popups: {
    name: string;
    emergencyCode: DeviceEmergencyCodeEnum[];
    onRepair: boolean;
  }[];
};
export default ({ popups }: Props) => {
  return popups?.length === 1 ? (
    <div className="marker-kns-vns">
      <div className="icon">
        {popups[0].onRepair ? (
          <RepairIcon />
        ) : someIncludes(popups[0].emergencyCode, [
            DeviceEmergencyCodeEnum.nonEmergency,
            DeviceEmergencyCodeEnum.phaseControlError,
          ]) ? (
          <GreenPointIcon />
        ) : (
          <ErrorIcon />
        )}
      </div>
      <div className="text">{popups[0].name}</div>
    </div>
  ) : (
    <div className="round-marker">{popups?.length}</div>
  );
};
